import PropTypes from 'prop-types'
import React from 'react'
import { Grid, ProductCard } from 'Blocks'
import config from 'Config'

const ProductGrid = ({
  pageName = '',
  products = [],
  isSearch = false,
  gaEventContext
}) => {
  return (
    <Grid className="product-list" pageName={pageName}>
      {products
        .filter(product => product.uuid)
        .map((product, index) => (
          <ProductCard
            product={product}
            key={`${product.uuid}-${index}`}
            position={index}
            pageName={pageName}
            gaEventContext={
              gaEventContext || (isSearch ? 'Search Page' : 'Category Page')
            }
            showStore={config.showStoreNameOnProductCard}
          />
        ))}
    </Grid>
  )
}

ProductGrid.propTypes = {
  gaEventContext: PropTypes.any,
  isSearch: PropTypes.bool,
  pageName: PropTypes.string,
  products: PropTypes.array
}

export default ProductGrid
